import React from 'react'
import styles from './SelectResource.module.scss'
import { TResource } from '../../../models/Resource'
import { resourceService } from '../../../services/ResourceService'
import { Button, Input, Spin } from 'antd'

interface Props {
  businessId: string
  onSelect: (businessId: string, item: TResource) => void
}

export const SelectResource = ({ businessId, onSelect }: Props) => {
  const [loading, setLoading] = React.useState(true)
  const [items, setItems] = React.useState<TResource[]>([])
  const [filteredItems, setFilteredItems] = React.useState<TResource[]>([])
  const [search, setSearch] = React.useState('')

  React.useEffect(() => {
    setLoading(true)
    resourceService.getBusinessResources(businessId)
      .then(setItems)
      .finally(() => setLoading(false))
  }, [businessId])

  React.useEffect(() => {
    setFilteredItems(search ? items.filter(i => `${i.name} ${i.surname}`.toLowerCase().includes(search)) : items)
  }, [search, items])

  return (
    <div className={styles.root}>
      {loading && (
        <div className={styles.loader}>
          <Spin size={'large'} />
        </div>
      )}
      {!loading && (
        <Input.Search
          allowClear
          className={'mb4'}
          value={search}
          onChange={e => setSearch(e.target.value.toLowerCase())}
        />
      )}

      {filteredItems.map(item => (
        <Button
          key={item.id}
          type={'link'}
          className={styles.item}
          onClick={() => onSelect(businessId, item)}
        >
          {item.name} {item.surname}
        </Button>
      ))}
    </div>
  )
}
